import { MultiPolygon, Polygon } from "geojson";
import { z } from "zod";

import { fetchWithError, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { AssetKey, getGeom } from "../assets";

export const rasterCurveSchema = z.object({
  results: z.array(z.tuple([z.number(), z.number().nullable()])),
});

export type RasterCurve = z.infer<typeof rasterCurveSchema>;

export function useRasterCurve(
  uuid: string,
  geometry: Polygon | MultiPolygon,
  assetKey?: AssetKey
) {
  const geom = getGeom(geometry, assetKey);
  const url = combineUrlAndParams(`/api/v4/rasters/${uuid}/curve/`, { geom });
  return useParsedQuery<RasterCurve>(
    ["lizard-api-v4", "rastercurve", url],
    () => fetchWithError(url),
    (json: unknown) => rasterCurveSchema.parse(json)
  );
}
